import DiSubcontDeliveryCard from '@/models/DiSubcontDeliveryCard/DiSubcontDeliveryCard';

export default class DiSubcontDeliveryCardFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.deliveryCardNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.dcQty = '';
		this.deliveryInstructionSubcontractDetailId  = '';
		this.deliveryInstructionSubcontractDetailPart = '';
		this.deliveryDateFrom = '';
		this.deliveryDateTo = '';
		this.sequence = '';
		this.totalDeliveryCard = '';
		this.transactionType = '';
		this.transactionId = '';
		this.isUsed = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			deliveryCardNumber : '0',
			partId : '0',
			partPartNumber : '0',
			dcQty : '0',
			deliveryInstructionSubcontractDetailId : '0',
			deliveryInstructionSubcontractDetailPart : '0',
			deliveryDateFrom : '0',
			deliveryDateTo : '0',
			sequence : '0',
			totalDeliveryCard : '0',
			transactionType : '0',
			transactionId : '0',
			isUsed : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}